export type EsnSortDirection = 'asc' | 'desc'

export interface EsnSortConfig {
  key: string
  direction: EsnSortDirection
}

export const DEFAULT_ESN_SORT: EsnSortConfig = { key: 'days', direction: 'desc' }

export function esnSortConfigKey(sort: EsnSortConfig): string {
  return `${sort.key}:${sort.direction}`
}

export function esnFreelancerSortToQueryParams(sort: EsnSortConfig): Record<string, string> {
  return {
    esn_freelancer_sort_key: sort.key,
    esn_freelancer_sort_dir: sort.direction,
  }
}

export function esnClientSortToQueryParams(sort: EsnSortConfig): Record<string, string> {
  return {
    esn_client_sort_key: sort.key,
    esn_client_sort_dir: sort.direction,
  }
}

export function esnSortsToQueryParams(
  freelancerSort: EsnSortConfig,
  clientSort: EsnSortConfig
): Record<string, string> {
  return {
    ...esnFreelancerSortToQueryParams(freelancerSort),
    ...esnClientSortToQueryParams(clientSort),
  }
}
